import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'topo-app-page',
    imports: [RouterOutlet],
    template: `<router-outlet />`
})
export class AppPageComponent {
  
}
